<template>
  <div>
    <v-dialog v-model="interestFormVueDialog" persistent max-width="900">
      <v-card min-height="600" loader-height="10">
        <!-- loading overlay -->
        <v-overlay dark absolute v-if="isLoading">
          <v-progress-circular indeterminate size="100" class="ma-0"></v-progress-circular>
        </v-overlay>
        <v-card-title class="primary text-white justify-between sticky">
          {{
          isCreate
          ? text.isCreate + text.title
          : isUpdate
          ? text.isUpdate + text.title
          : "-"
          }}
          <v-btn color="white" icon @click="onCancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <interest-form
          :objectId="objectId"
          :isCreate="isCreate"
          :isUpdate="isUpdate"
          :value="value"
          :approveId="objectId"
          :areaIds="areaIds"
          @onLoading="isLoading = $event"
          @onCreate="emitCreate"
          @onUpdate="emitUpdate"
          @onCancel="interestFormVueDialog = false"
          @onSuccess="onSuccess"
        ></interest-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomerCard from "./CustomerCard.vue";
import CustomerSearchDialog from "./CustomerSearchDialog.vue";
import QuotationDialog from "./QuotationDialog.component.vue";
import InterestForm from "./InterestForm.vue";
export default {
  components: {
    CustomerSearchDialog,
    CustomerCard,
    QuotationDialog,
    InterestForm
  },
  name: "InterestFormVue",
  computed: {
    admin() {
      return this.getAdminByMarketId(this.marketId);
    },
    ...mapGetters({
      getAdminByMarketId: "admin/getByMarketId",
      getEmployeeByMarketId: "employee/getByMarketId",
      getAreas: "markets/getAreas",
      areaInterest: "areaInterest/getAreaInterest"
    }),
    interestFormVueDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    marketId() {
      return this.$route.params.marketId;
    }
  },
  watch: {
    // value(data) {
    //   if (data) {
    //     // this.resetForm();
    //     this.initData();
    //   }
    // },
  },
  created() {},
  data() {
    return {
      rules: {
        firstName: v => !!v || this.$t('validate.please_input_customer_name'),
        lastName: v => !!v || this.$t('validate.please_input_customer_last_name'),
        tel: v => !!v || this.$t('validate.please_input_customer_phone')
      },
      quotationId: null,
      isQuotation: false,
      form: {
        contractStartDate: this.$moment().format("YYYY-MM-DD"),
        contractEndDate: this.$moment()
          .add(1, "month")
          .format("YYYY-MM-DD"),
        contractType: "long",
        customerFirstName: "",
        customerLastName: "",
        customerTel: "",
        customerCustomerType: "personal",
        isNewCustomer: false,
        areasQty: 1,
        areaIds: [],
        sellProduct: "",
        note: ""
      },
      text: {
        title: this.$t('market.interested_in_business'),
        isCreate: this.$t('action_type.add'),
        isUpdate: this.$t('action_type.edit')
      },
      menuStartDate: false,
      menuEndDate: false,
      select: 1,
      searchDialog: false,
      currentCustomer: null,
      isError: false,
      errorMsg: "",
      isLoading: false,
      isDisable: false,
      statusResponse: null,
      isLoading: false
    };
  },
  props: {
    value: Boolean,
    objectId: String,
    isUpdate: Boolean,
    isCreate: Boolean,
    approveId: String,
    areaIds: Array
  },
  methods: {
    emitCreate(e) {
      this.$emit("onCreate", e);
    },
    emitUpdate(e) {
      this.$emit("onUpdate", e);
    },
    onSuccess(e) {
      this.$emit("onSuccess", e);
    },
    onCancel() {
      try {
        this.interestFormVueDialog = false;
        this.$emit("onCancel", this.form);
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.active-select {
  @apply border-screamin-green-600 text-screamin-green-600 bg-screamin-green-50;
}
</style>
